import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageEditComponent } from './image-edit/image-edit.component';
import { TextAreaEditComponent } from './text-area-edit/text-area-edit.component';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    ImageEditComponent,
    TextAreaEditComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatInputModule
  ],
  exports: [
    ImageEditComponent,
    TextAreaEditComponent
  ]
})
export class ImageEditModule { }
